import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/authservice/auth.service';

@Component({
  selector: 'app-role-modal',
  templateUrl: './role-modal.component.html',
  styleUrls: ['./role-modal.component.scss'],
  standalone: false
})
export class RoleModalComponent {
  @Input() isModalOpen: boolean = false;
  @Input() selectedRole: string = 'Teacher';
  @Input() emailAddress: string = '';

  @Output() close = new EventEmitter<void>();
  @Output() continueEvent = new EventEmitter<string>();
  isWaiting = false;
  errorMessage: string = '';

  constructor(private authService: AuthService, public translate:TranslateService,
    private router:Router
  ) {}

  closeModal(): void {
    this.close.emit();
  }

  // Simple regex for email validation
  isValidEmail(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  onContinue(): void {
    // Clear any previous error and set waiting flag
    this.errorMessage = '';
    this.isWaiting = true;
  
    // Validate email is provided
    if (!this.emailAddress) {
      this.errorMessage = 'Email is required';
      this.isWaiting = false;
      return;
    }
  
    // Validate email format
    if (!this.isValidEmail(this.emailAddress)) {
      this.errorMessage = this.translate.instant('general.emailIsInvalid');
      this.isWaiting = false;
      return;
    }
  
    // Check if email exists using the object-based subscribe
    this.authService.checkEmailExistence(this.emailAddress).subscribe({
      next: (exists: boolean) => {
        if (exists) {
          // Instead of simply showing an error message, navigate to login
          // and pass the email via query params for pre-filling.
          this.router.navigate(['/auth/login'], { queryParams: { email: this.emailAddress } });
        } else {
     // Email is valid and not already used; redirect to register with role and email in query params
     this.router.navigate(['/auth/register', this.selectedRole], { queryParams: { email: this.emailAddress } });
     this.closeModal();
        }
        this.isWaiting = false; // Reset waiting state
      },
      error: (error: any) => {
        console.error('Error checking email:', error);
        this.errorMessage = this.translate.instant('general.errorChickingEmailTryLater');
        this.isWaiting = false;
      }
    });
  }
  
}